interface BaseIconProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
}

export const BaseIcon: React.FC<{
  children: React.ReactNode;
  gradientId: string;
} & BaseIconProps> = ({ 
  children, 
  gradientId, 
  size = 24, 
  className = "",
  strokeWidth = 2.5
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <defs>
      <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#00D4FF" />
        <stop offset="100%" stopColor="#00B8D4" />
      </linearGradient>
    </defs>
    {children}
  </svg>
);

export type { BaseIconProps };
